<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<Subscription :customer="customer_id" />
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    loading: false,
    customer_id: false
  }),
  methods: {
    getId () {
      return this.$route.params.id
    }
  },
  created () {
    Vue.$api.get('/new-subscription/' + this.getId(), {}, {
      loader: toggle => this.loading = toggle,
      callback: data => this.customer_id = Number(data.customer_id)
    })
  }
}
</script>
